import { BULLET_SYMBOL } from 'frontend/constants/whiteboard';

export const addMacroBullet = text => text.replace(/(^|\n)(\s*-\s)/g, `$1${BULLET_SYMBOL}`);

export const addNewLineBullet = text =>
  text.replace(new RegExp(`((^|\n)${BULLET_SYMBOL}[^\n]+\n)(\n|$)`, 'g'), `$1${BULLET_SYMBOL}$3`);

export const countBullets = text =>
  text.match(new RegExp(`(^|\n)${BULLET_SYMBOL}`, 'g'))?.length || 0;
